import styled from "styled-components";

export const ModalScroll = styled.div`
  height: 220px;
  overflow-y: auto;
  scroll-behavior: smooth;
  text-align: justify;
  padding-right: 10px;
`;

export const ModalButton = styled.span`
width: 160px;
height: 22px;
border-radius: 12px;
background-color: #12d258;
font-size: 11px;
left: 24px;
top: auto;
justify-content: center;
align-items: center;
display: flex;
color: white;
cursor: pointer;
user-select: none;
margin-left: 10px;
&:hover {
  opacity: 0.85;
}

${({ disabled }) => disabled && `
    background: gray;
    pointer-events: none; 
  `}
`;


export default { ModalScroll, ModalButton };